import JiuJitsu2 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7029.jpg"
import JiuJitsu3 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7031.jpg"
import JiuJitsu4 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7032.jpg"
import JiuJitsu5 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7044.jpg"
import JiuJitsu7 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7076.jpg"
import JiuJitsu8 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7090.jpg"
import JiuJitsu10 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7107.jpg"
import JiuJitsu11 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7112.jpg"
import JiuJitsu12 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7115.jpg"
import JiuJitsu13 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7119.jpg"
import JiuJitsu14 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7125.jpg"
import JiuJitsu15 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7133.jpg"
import JiuJitsu16 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7150 2.jpg"
import JiuJitsu17 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7153 2.jpg"
import JiuJitsu18 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7155 2.jpg"
import JiuJitsu19 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7170 2.jpg"
import JiuJitsu20 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7171 2.jpg"
import JiuJitsu21 from "../../../assets/general_assets/jiu-jitsu-photos/IMG_7175 2.jpg"

const imgs = [
    JiuJitsu2,
    JiuJitsu3,
    JiuJitsu4,
    JiuJitsu7,
    JiuJitsu8,
    JiuJitsu10,
    JiuJitsu11,
    JiuJitsu12,
    JiuJitsu13,
    JiuJitsu14,
    JiuJitsu15,
    JiuJitsu16,
    JiuJitsu17,
    JiuJitsu18,
    JiuJitsu19,
    JiuJitsu20,
    JiuJitsu21,
]

export default imgs;